<template>
  <div class="download-fixed-box">
    <div :class="getButtonBoxClassName()">
      <wx-open-launch-app v-if="isWXStatus"
                          id="launch-btn"
                          class="open-launch-button"
                          :extinfo="appParams"
                          @error="handleErrorFn" 
                          @launch="handleLaunchFn" 
                          appid="wxc935b94e9de4096f">
        <script type="text/wxtag-template">
          <style></style>
          <div class="btn">&nbsp;</div>
        </script>
      </wx-open-launch-app>
      <div class="download-button-show-box show-flex-box-r show-flex-center"
          @click.stop="clickOpenDownloadPage()"
        >
        <!-- <strong>{{buttonText}}</strong> -->
        <slot v-if="slotStatus"></slot>
        <strong v-else>{{buttonText}}</strong>
      </div>
    </div>
  </div>
</template>

<script>
/**
 引用：import openAppButton from '@/components/common/open_app_button_comp';
 
<open-app-button androidLink='http://www.sina.com.cn'
                 iosLink='http:/www.baidu.com'
                 appParams='xcr://XXX'
  >
</open-app-button>
 */
import { configWxShareByServe } from "@/utils/configWX";
import Dplink from '@/components/dplink';

export default {
  name: "openAppButton",
  props: {
    showType: [String],
    wxConfig: [Object],
    appParams: [String,Object,Array],
    slotStatus: [Boolean],
    buttonText: {
      type: String,
      default: '打开APP', // 立即下载
    },
    androidLink: {
      type: String,
      default: 'https://www.pgyer.com/yspandroid',
    },
    iosLink: {
      type: String,
      default: 'https://apps.apple.com/cn/app/%E5%8C%BB%E8%A7%86%E5%B1%8F/id6445982037',
    },
  },
  data() {
    return {
      isWXStatus: false,
      phoneSystemType: '',
      dplink: '',
    };
  },
  mounted() {
    this.initOpenShowData();
    this.setWxConfigInfo();
    this.dplink = new Dplink({
      schemeLink: this.appParams,
      // universalLink: this.appParams,
      downloadLink:{
          ios: this.iosLink,
          android: this.androidLink
      },
      // autoOpen:true,
      autoOpen:false,
      success:function(){
        console.log('open success');
      },
      fail:function(){
        console.log('open failed');
      },
      timeout:500,
      way:'auto',// default: auto; iframe|location|lin
    })
    
    // this.dplink.bind('#open_app_btn');
  },
  methods: {
    initOpenShowData: function() {
      this.isWXStatus = this.getIsWeiXinStatus();
      this.phoneSystemType = this.getSystemType();
    },
    setWxConfigInfo: function() {
      configWxShareByServe(this.wxConfig || {});
    },
    getButtonBoxClassName: function() {
      let clsName = 'download-btn';

      if (this.showType) {
        clsName = clsName + ''
      }

      return clsName;
    },
    getIsWeiXinStatus: function(){
      var ua = window.navigator.userAgent.toLowerCase();
      
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        return true;
      }else{
        return false;
      }
    },
    getSystemType: function() {
      var systemType = '';

      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        systemType = 'ios';
      } else { //判断Android 和 pc
        systemType = 'android';
      }

      return systemType;
    },
    handleErrorFn: function(e) {
      this.openDownloadPage();
    },
    handleLaunchFn: function(e) {
      // let escapeText = escape(this.appParams);
      let escapeText = this.appParams;
      this.copyText(escapeText);

      // var unescape1 = unescape(escape1); //解码
    },
    copyText(text, callback){ // text: 要复制的内容， callback: 回调
        var tag = document.createElement('input');
        tag.setAttribute('id', 'cp_hgz_input');
        tag.value = text;
        document.getElementsByTagName('body')[0].appendChild(tag);
        document.getElementById('cp_hgz_input').select();
        document.execCommand('copy');
        document.getElementById('cp_hgz_input').remove();
        if(callback) {callback(text)}
    },
    clickOpenDownloadPage: function() {
      this.openDownloadPage();
    },
    openDownloadPage: function() {
      // switch (this.phoneSystemType) {
      //   case 'android':
      //     window.location.href = this.androidLink;
      //   break;
      //   case 'ios':
      //     window.location.href = this.iosLink;
      //   break;
      // }
      console.log(this.dplink);
      this.dplink.open();
    },
    openDownloadAppPage: function() { 
      this.sendClickInfo();
    },
  }
};
</script>

<style lang="less" scoped>
  .download-fixed-box {
    width: 100%;
    height: 100%;
    &>div {
      position: relative;
      width: 100%;
      height: 100%;
      &>.open-launch-button {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
      }
      &>.open-launch-button:active {
        background: rgba(255,255,255,0.3);
      }
      &>div {
        width: 100%;
        height: 100%;
        &>strong {
          font-size: 0.16rem;
          font-family: SourceHanSerifSC-Bold, SourceHanSerifSC;
          line-height: 0.44rem;
          text-align: center;
          color: #fff;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/common/open_app_button_comp.vue